import { render, staticRenderFns } from "./RegistrationNumberRetentionTime.vue?vue&type=template&id=3cb40de1&scoped=true&"
import script from "./RegistrationNumberRetentionTime.vue?vue&type=script&lang=js&"
export * from "./RegistrationNumberRetentionTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb40de1",
  null
  
)

export default component.exports